/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *  ╔═○─┐ emotive
 *    ●●  ENGINE - Slide Left Gesture
 *  └─○═╝
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *
 * Smooth glide to the left (2 beats)
 */

import { createSlideGesture } from './danceSteps.js';

export default createSlideGesture('left');
